function validateDomainAndGetStoreUrl(_ref) {
  let {
    client,
    storeDomain
  } = _ref;
  try {
    if (!storeDomain || typeof storeDomain !== 'string') {
      throw new Error();
    }
    const trimmedDomain = storeDomain.trim();
    const protocolUrl = trimmedDomain.match(/^https?:/) ? trimmedDomain : "https://".concat(trimmedDomain);
    const url = new URL(protocolUrl);
    url.protocol = 'https';
    return url.origin;
  } catch (error) {
    throw new Error("".concat(client, ": a valid store domain (\"").concat(storeDomain, "\") must be provided"), {
      cause: error
    });
  }
}
function validateApiVersion(_ref2) {
  let {
    client,
    currentSupportedApiVersions,
    apiVersion,
    logger
  } = _ref2;
  const versionError = "".concat(client, ": the provided apiVersion (\"").concat(apiVersion, "\")");
  const supportedVersion = "Currently supported API versions: ".concat(currentSupportedApiVersions.join(', '));
  if (!apiVersion || typeof apiVersion !== 'string') {
    throw new Error("".concat(versionError, " is invalid. ").concat(supportedVersion));
  }
  const trimmedApiVersion = apiVersion.trim();
  if (!currentSupportedApiVersions.includes(trimmedApiVersion)) {
    if (logger) {
      logger({
        type: 'Unsupported_Api_Version',
        content: {
          apiVersion,
          supportedApiVersions: currentSupportedApiVersions
        }
      });
    } else {
      console.warn("".concat(versionError, " is likely deprecated or not supported. ").concat(supportedVersion));
    }
  }
}
export { validateApiVersion, validateDomainAndGetStoreUrl };